var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAws(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.42542 15.985C2.83059 23.3792 8.61621 44.9703 5.25022 38.2384C4.88758 37.5131 4.5853 36.8983 4.5548 36.0748C4.44204 33.0302 4.21484 29.847 3.16396 26.9571C2.28496 24.5399 2.46854 22.0341 2.46854 19.462C2.46854 18.9468 1.59298 14.8924 1.67654 14.8646C2.56154 14.5696 6.21282 19.0063 6.87287 19.7711C10.2111 23.6393 13.5857 28.0844 15.9713 32.6171C17.1992 34.95 17.5691 35.7858 14.6384 36.1521",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.078 30.9365C4.34074 29.281 7.44907 27.9579 10.8139 26.764",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4662 16.3327C13.8074 21.3374 16.989 26.663 20.8782 31.2842C21.4328 31.9433 22.5974 33.1405 22.5974 31.5933C22.5974 29.482 21.428 27.3002 20.8975 25.2959C20.0488 22.0899 19.259 18.8691 18.5408 15.6373C17.8475 12.5174 18.336 13.6823 19.5066 16.0236C21.4466 19.9035 23.4888 23.4375 26.1904 26.8799C28.0105 29.1991 28.1994 27.9075 28.1994 25.8754C28.1994 22.1839 26.3972 19.1484 25.07 15.8304C23.6523 12.2862 23.7473 7.4479 22.1338 4.2208C21.5063 2.9658 21.4192 6.94306 21.2452 8.33537",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2424 3.81512C29.3311 4.22354 30.6258 14.3467 32.9127 13.2033C33.9147 12.7023 34.1604 11.1693 35.1921 10.6534C36.8639 9.81755 38.6706 11.2979 39.326 12.7397C41.0589 16.552 39.0642 20.9674 35.9262 23.2869C31.579 26.5 33.0672 20.7156 33.0672 19.1143",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3287 3.11973C30.7028 4.82963 29.5654 12.7685 29.2231 9.68758C29.0118 7.78585 29.3869 6.33974 29.5901 4.51057C30.0722 0.171529 33.3926 3.66197 32.0241 1.38118",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAws);
export default __webpack_public_path__ + "static/media/aws.63c3fb572a510a9950de990ae7295c0b.svg";
export { ForwardRef as ReactComponent };